import { apiConstants } from './shared/config';

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao" */ './views/Home.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `global.manage`,
        }
    },
    {
        path: `/${apiConstants.code}/settings`,
        name: `${apiConstants.code}.settings`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-settings" */ './views/settings/DefinitionsDetails.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `settings.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/print`,
        name: `${apiConstants.code}.print_visible_emissions`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-print_visible_emissions" */ './views/print/PrintVisibleBase.vue'),
        children: [
            {
                path: 'config',
                name: `${apiConstants.code}.print_visible_emissions.config`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-print_visible_emissions" */ './views/print/PrintVisibleConfig.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'print_visible_emissions.title',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'print_visible_emissions.title',
        }
    },
    {
        path: `/${apiConstants.code}/worktypes`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-worktypes" */ './views/worktype/WorkTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.worktypes`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-worktypes" */ './views/worktype/WorkTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Naturezas de Obra',
                }
            },
            {
                path: 'config',
                name: `${apiConstants.code}.worktypes.config`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-worktypes" */ './views/worktype/WorkTypeConfig.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Naturezas de Obra',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.worktypes.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-worktypes" */ './views/worktype/WorkTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Natureza de Obra',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.worktypes.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-worktypes" */ './views/worktype/WorkTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Natureza de Obra',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Naturezas de Obra',
        }
    },
    {
        path: `/${apiConstants.code}/maps`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-maps" */ './views/map/MapBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.plans`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-maps" */ './views/map/MapList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Mapas',
                }
            },
            {
                path: 'config',
                name: `${apiConstants.code}.plans.config`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-maps" */ './views/map/MapConfig.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Mapa',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.plans.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-maps" */ './views/map/MapDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Mapa',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.plans.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-maps" */ './views/map/MapDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Mapa',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Mapas',
        }
    },
    {
        path: `/${apiConstants.code}/pmdfcis`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-pmdfcis" */ './views/pmdfci/PmdFciBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.pmd_fcis`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-pmdfcis" */ './views/pmdfci/PmdFciList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Planos PMDFCI',
                }
            },
            {
                path: 'config',
                name: `${apiConstants.code}.pmd_fcis.config`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-pmdfcis" */ './views/pmdfci/PmdFciConfig.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Planos PMDFCI',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.pmd_fcis.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-pmdfcis" */ './views/pmdfci/PmdFciDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Plano PMDFCI',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.pmd_fcis.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-pmdfcis" */ './views/pmdfci/PmdFciDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Plano PMDFCI',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Planos PMDFCI',
        }
    },
    {
        path: `/${apiConstants.code}/pis`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-pis" */ './views/pis/PisBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.pis`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-pis" */ './views/pis/PisList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Planos PIS',
                }
            },
            {
                path: 'config',
                name: `${apiConstants.code}.pis.config`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-pis" */ './views/pis/PisConfig.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Planos PIS',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.pis.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-pis" */ './views/pis/PisDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Plano PIS',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.pis.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-pis" */ './views/pis/PisDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Plano PIS',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Pedido Informação Simples',
        }
    },
    {
        path: `/${apiConstants.code}/defaultlayers`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.default_layers`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.default_layers.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.default_layers.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `default_layers.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/layers`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-layers" */ './views/layer/LayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.layers`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-layers" */ './views/layer/LayerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Camadas',
                }
            },
            {
                path: ':type',
                name: `${apiConstants.code}.layers.create`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-layers" */ './views/layer/LayerDetails.vue'),
                beforeEnter: (to, from, next) => {
                    let available = ['group', 'resource'];
                    if (available.indexOf(to.params.type) == -1){
                        next(false)
                    }else{
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Camada',
                }
            },
            {
                path: 'group/:id',
                name: `${apiConstants.code}.layers.show.group`,
                props: {isLayer: false},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Camada',
                }
            },
            {
                path: 'resource/:id',
                name: `${apiConstants.code}.layers.show.item`,
                props: {isLayer: true},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Camada',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Camadas',
        }
    },
    {
        path: `/${apiConstants.code}/regulations`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-regulation" */ './views/regulation/RegulationBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.regulations`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-regulation" */ './views/regulation/RegulationList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Regulamentos',
                }
            },
            {
                path: ':type',
                name: `${apiConstants.code}.regulations.create`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-regulation" */ './views/regulation/RegulationDetails.vue'),
                beforeEnter: (to, from, next) => {
                    let available = ['group', 'item'];
                    if (available.indexOf(to.params.type) == -1){
                        next(false)
                    }else{
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Regulamento',
                }
            },
            {
                path: 'group/:id',
                name: `${apiConstants.code}.regulations.show.group`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-regulation" */ './views/regulation/RegulationDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Regulamento',
                }
            },
            {
                path: 'item/:id',
                name: `${apiConstants.code}.regulations.show.item`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "eplgestao-regulation" */ './views/regulation/RegulationDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Regulamento',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Regulamentos',
        }
    },
];

export default routes;